import React from 'react';
import { Input, Button, CheckboxTable, Select, Textarea } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Socket } from 'utils';
import { CallService, ChatService } from 'services';
import { connect } from 'react-redux';

interface Props extends RootState {
  onClose?: any;
}

class ModalCreate extends React.Component<Props> {
  state = {
    form: {
      area_id: '',
      message: '',
    },
    areas: [],
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await ChatService.getAreas();
    this.setState({
      areas: res.areas || [],
    });
  };

  submit = async (e: any) => {
    e.preventDefault();
    const { form } = this.state;

    if (!form.area_id) {
      Globals.showError('Debe seleccionar el área');
      return;
    }

    if (!form.message) {
      Globals.showError('Debe ingresar un mensaje');
      return;
    }

    try {
      const res: any = await ChatService.save({
        sender_id: this.props.user?.id,
        ...this.state.form,
      });
      this.props.onClose(res.chat?.id);
    } catch (err: any) {
      const data = err?.response?.data;
      const message =
        data?.error?.message ||
        (typeof data?.message === 'string' ? data.message : null) ||
        'Ha ocurrido un error, por favor intente nuevamente';
      Globals.showError(message);
    }
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  render() {
    return (
      <form id='modal-create-chat' onSubmit={this.submit}>
        <Select
          color='white'
          placeholder='Seleccionar'
          label='Tipo de derecho'
          name='area_id'
          onChange={this.change}
          value={this.state.form.area_id}
          options={this.state.areas.map((item: any) => {
            return {
              value: item.id,
              label: item.name,
            };
          })}
        />
        <Textarea
          rows={6}
          value={this.state.form.message}
          placeholder='Mensaje'
          name='message'
          onChange={(e: any) => this.change(e)}
        />
        <div className='text-center'>
          <Button type='submit'>Enviar</Button>
        </div>
      </form>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(ModalCreate);
